import React, { useEffect, useState, useContext } from "react";
import jsonData from "../Data.json";
import { Link, Route, Router, useNavigate } from "react-router-dom";
import AdminImg from "../../Img/viewer.png";
import NewCampraLogo from "../../Img/camptralogo.png";
import Viewer from "../../Img/user_8777874.png";
// import campraImg from "../../Img/LOGORepository.png"
import campraImg from "../../Img/CT.png";
import LogoSidebar from "../../Img/Screenshot__1945_-removebg-preview.png";
import HCM from "../../Img/hcm_people_1769041.png";
import ERP from "../../Img/erp_5622496.png";
import SCM from "../../Img/supply-chain-management_4249182.png";
import EPM from "../../Img/epm_project-management_9042937.png";
import adminpage from "../../Img/admin page.png";
import CategoryList from "./CategoryList";
import myarticles from "../../Img/new article.png";
import SearchResults from "./SearchResults";
// import { Button, Collapse } from 'bootstrap';
import { FaArrowLeft, FaArrowLeftLong, FaArrowRight } from "react-icons/fa6";
import axios from "axios";
import { Dropdown, Spinner } from "react-bootstrap";
import SideBar from "../SideBar";
import { API_BASE_URL } from "../../utils/config";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import TopNavBar from "../TopNavBar";
import HamburgerNavigation from "../HamburgerNavigation";
import InnerHamburgerNavigation from "../InnerHamburgerNavigation";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate"; // for pagination
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"; // icons form react-icons
import { IconContext } from "react-icons";
import NewTopNavBar from "../NewTopNavBar";
import { filterDataByUserTags } from "../../utils/commons";
import AiImg from "../../Img/AI-chat.png";
// import { Modal } from 'react-bootstrap';
import GlobalContext from "../../context/GlobalContext";
import Modal from "../Modal";
import { useLog } from "../../context/LogContext";
import ShowCatInf from "./ShowCatInf";

const SearchLandingPage = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [apiResponse, setApiRespose] = useState([]);
  const [allRes, setRes] = useState([]);
  const [isButtonVisible, setButtonVisible] = useState(true);
  // const [collapse, setCollapse] = useState()
  const [isDisplayNone, setIsDisplayNone] = useState(false);
  const [postTitles, setPostTitles] = useState([]);
  const [count, setcount] = useState(1);
  const [logoutBtnView, setLogoutBtnView] = useState(false);
  const [catagories, setCatagories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [spnierLoading, setSpnierLoading] = useState(false);
  const [allCategories, setALLCategories] = useState([]);
  const [collaps, setCollaps] = useState(true);
  const [categoriesWithCount, setCategoriesWithCount] = useState([]);
  const [page, setPage] = useState(0);
  const [filterData, setFilterData] = useState();
  const n = 6;

  const { chatModal, setChatModal } = useContext(GlobalContext);

  const { logApiRequest } = useLog();
  // let inputQuery;
  const handleInputChange = (e) => {
    const inputQuery = e.target.value;

    setQuery(inputQuery);
  };
  //
  let bearerToken = localStorage.getItem("jwt_token");
  // useEffect(() => {
  //   // Fetch WordPress post titles based on the query

  //
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (query.trim() !== "") {
        fetchPostTitles();
      } else {
        setPostTitles([]);
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [query]);
  //
  const fetchPostTitles = () => {
    if (query) {
      let request = {
        method: "GET",
        url: `${API_BASE_URL}/wp-json/wp/v2/posts?search='${query}'&per_page=100`,
      };
      const startTime = new Date();
      fetch(
        `${API_BASE_URL}/wp-json/wp/v2/posts?search='${query}'&per_page=100`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          const endTime = new Date();
          logApiRequest(request, response, startTime, endTime);
          response.json();
        })

        .then((data) => {
          // Assuming the response contains post titles as an array
          data = filterDataByUserTags(data);
          setPostTitles(data);
          console.log(data);
        })
        .catch((error) => {
          console.error(error);
          localStorage.removeItem("jwt_token");
          localStorage.removeItem("tags");
          logApiRequest(request, error.response || { status: error.message });
          navigate("/");
        });
    } else {
      // Clear post titles if the query is empty
      setPostTitles([]);
    }
  };
  // }, [query]);

  //
  localStorage.setItem("searchQuery", query);
  useEffect(() => {
    if (!bearerToken) {
      navigate("/");
    }

    if (query == "") {
      // alert("scfs")
      localStorage.setItem("searchQuery", query);
    }
    // if (query)

    if (query) {
      const filteredSuggestions = jsonData.filter((item) =>
        item.title.toLowerCase().includes(query.toLowerCase())
      );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  }, [query]);

  //
  const getTenentData = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "multipart/form-data",
        // 'X-Wp-Nonce': '6de9be6ced',
        // 'Content-Type': 'application/json',
      },
    };
    const currentUserId = localStorage.getItem("current_user_Id");
    axios
      .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`, config)
      .then((res) => {
        console.log("telentData76=", res.data);
        if (res.data.length > 0) {
          const TenentData = res.data.filter((data) => {
            if (data.tenent_user_id == currentUserId) {
              return data;
            }
          });

          console.log("tenantData=", TenentData);
          if (TenentData.length < 1) {
            alert("You are not Authorized for login please connect to admin.");
            localStorage.removeItem("jwt_token");
            localStorage.removeItem("tags");
            navigate("/");
            window.location.reload();
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  //

  // const handleSuggestionClick = (item) => {
  //   // Redirect to the results page with the selected item's ID as a parameter
  //   navigate(`/results?id=${item.id}`);
  // };
  // Add a click event listener to hide suggestions when clicking anywhere on the window
  useEffect(() => {
    // if (localStorage.getItem("roles") == "editor") {
    //   getTenentData();
    // }
    const handleWindowClick = () => {
      setSuggestions([]); // Clear suggestions when clicking anywhere on the window
    };

    window.addEventListener("click", handleWindowClick);

    return () => {
      window.removeEventListener("click", handleWindowClick);
    };

    //

    //
  }, []);
  const backBtn = () => {
    navigate("/table-posts");
  };
  const handleSearch = (e) => {
    e.preventDefault(); // Prevent form submission
    if (query == "") {
      toast.error("Enter text to perform a search.");
      return;
    } else if (query.length == 1) {
      toast.error("Please provide additional text to refine your search.");
      return;
    }
    localStorage.removeItem("subcategoryId");
    localStorage.removeItem("catagoryId");
    navigate(`/results`);
  };
  const storedEmail = localStorage.getItem("userEmail");

  const CollapseSidbarBtn = () => {
    // setCollapse(1)
    setIsDisplayNone(!isDisplayNone);
  };

  let catagoryId = localStorage.getItem("catagoryId");
  // alert(catagoryId)

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        let response = await axios.get(
          `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`,
          {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const categoryData = response.data.map((category) => ({
          id: category.id,
          name: category.name,
        }));

        setALLCategories(categoryData);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();

    //get categories with count start

    const getCategoriesWithCount = async () => {
      setLoading(true);
      setSpnierLoading(true);
      // alert("alert1")
      // setSpnierLoading(spnierLoading ? false : true)
      const request = {
        method: "GET",
        url: `${API_BASE_URL}/wp-json/custom-category/v1/get-all-categories`,
      };
      const startTime = new Date();
      try {
        const response = await axios.get(
          `${API_BASE_URL}/wp-json/custom-category/v1/get-all-categories`,
          {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const endTime = new Date();
        logApiRequest(request, response, startTime, endTime);

        axios
          .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`)
          .then((res) => {
            const whitlistUrl = res.data.filter((res) => {
              if (res.url.includes(window.location.origin)) {
                return res;
              }
            });

            console.log("whitelist url=", whitlistUrl);

            const parentCategory = response.data.filter((data) => {
              if (
                data.parent == 0 &&
                whitlistUrl[0].category.includes(data.id) &&
                whitlistUrl[0].toggle_status == true
              ) {
                return data;
              }
            });

            // const parentCategory = response.data.filter((data) => {
            //   // console.log('line279=', whitlistUrl[0].category.includes(data.id))
            //   if (data.parent == 0) {
            //     return data;
            //   }
            // });

            console.log("283=", parentCategory);
            // setLoading(false)

            // setCategoriesWithCount(response.data);
            setCategoriesWithCount(parentCategory);
            // setSpnierLoading(spnierLoading ? false : true)
            setSpnierLoading(false);
            console.log("spinerloading=", spnierLoading);
            // alert('alert2')
          })
          .catch((err) => {
            console.log(err);
            // alert('alert3')
          });
      } catch (error) {
        console.error("Error fetching categories:", error);
        logApiRequest(request, error.response || { status: error.message });
        localStorage.clear();
        window.location.reload();
        navigate("/");
        // alert('alert4')
      } finally {
        setLoading(false);
        // alert('alert5')
      }
    };

    getCategoriesWithCount();
    //get categories with count start
    // if()

    //
  }, [catagoryId, apiResponse]);

  //

  useEffect(() => {
    setFilterData(
      categoriesWithCount.filter((item, index) => {
        return (index >= page * n) & (index < (page + 1) * n);
      })
    );
  }, [page, apiResponse, categoriesWithCount]);

  //
  // let count = 0;

  const gotToArticlePage = (postId) => {
    // localStorage.setItem("postId", postId)
    navigate(`/single-article?id=${postId}`);
  };

  const catagoryHandle = (catId, catName) => {
    // alert(catId)
    localStorage.setItem("catagoryId", catId);
    localStorage.setItem("categoryName", catName);
    // navigate('/category-posts')
    navigate("/subcategory");
  };

  // setSpnierLoading(true)

  console.log("line331=", window.location);

  //get whitelist data start

  // get whitelist data end

  const isTabletView = window.innerWidth >= 768 && window.innerWidth <= 992;

  return (
    <div>
      <div className="row g-0">
        {/* HamburgerNavigation */}
        <div className="col-12 hamburger">
          <InnerHamburgerNavigation />
        </div>

        <div
          className={
            collaps
              ? "column right-column  col bg-white"
              : "column right-column  col bg-white"
          }
          // className="column right-column  col-9"
          style={{ minHeight: "92vh" }}
        >
          {/* <!-- Content for the right column goes here --> */}
          <div className="top-nav">
            {/* <TopNavBar /> */}
            <NewTopNavBar />
          </div>
          {/* navbar */}
          <HamburgerNavigation />

          {/* chat modal open start */}
          {console.log("line401=", chatModal)}

          {/* <Modal show={chatModal} onHide={handleClose} centered>

            <Modal.Body className='p-0'>  <div className='row g-0 w-100 ' style={{ height: '80vh' }}>

              <iframe
                className=" w-100"
                src="https://kr.camptratech.com/chatopenai"
              ></iframe>
            </div>
            </Modal.Body>

          </Modal> */}

          {/* chat modal open end */}

          <div className="w-100 position-relative">
            {/* <div className='p-4'>
              <button style={{ border: 'none' }} onClick={CollapseSidbarBtn} className="  order-1 order-lg-0 me-4 me-lg-0 "><i className="fas fa-bars" ></i></button>
            </div> */}
            <div className="w-100 pt-5 fw-bold">
              <div className="d-flex flex-column justify-content-center">
                {/* <h2 className='fw-bold'>Knowledge Base</h2> */}
                <p style={{ fontSize: "28px" }}>Search for Articles</p>
              </div>
            </div>
            <div className="search-back w-100">
              <form
                role="search"
                method="get"
                className="search-form mb-5"
                onSubmit={handleSearch}
              >
                <label style={{ flex: "1", background: "#ffffff59" }}>
                  <input
                    type="text"
                    className="search-field"
                    placeholder="Search..."
                    value={query}
                    onChange={handleInputChange}
                  />
                </label>
                <button type="submit" className="search-submit">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"
                    />
                  </svg>
                </button>

                {/* <SearchResults results={suggestions} /> */}
              </form>
              {/* <div>
                <img src={AiImg} alt="" />
              </div> */}
            </div>
            {query.trim() !== "" && (
              <ul className={collaps ? "suggestion-list2" : "suggestion-list"}>
                {postTitles
                  ? postTitles.map((title, index) => (
                      <div
                        className="p-0 m-0 suggestion-link"
                        onClick={() => gotToArticlePage(title.id)}
                      >
                        <li key={index} className="m-0 suggestion">
                          {title.title.rendered}
                        </li>
                      </div>
                    ))
                  : ""}
              </ul>
            )}
          </div>
          {/* Infinite scroll start */}
          {/* <div style={{ padding: "0 100px" }}>
            <ShowCatInf />
          </div> */}
          {/* Infinite scroll end */}
          {/* {spnierLoading?<div} */}
          {console.log("spiner=", spnierLoading)}
          {/* shwoing categories box */}
          {spnierLoading ? (
            <div className="d-flex justify-content-center w-100">
              <Spinner />
            </div>
          ) : categoriesWithCount.length > 0 ? (
            <div
              className="w-100 "
              style={{ padding: isDisplayNone ? "0 100px" : "0 0px" }}
            >
              <div
                className={
                  isDisplayNone
                    ? "container-fluid post-container1 row pe-0 "
                    : "post-container1 row  g-0"
                }
                // className="post-container1 row  container "
              >
                <div style={{ minHeight: "40vh" }} className="row">
                  {console.log("categoriesWithCount=", filterData)}
                  {filterData.length > 0 ? (
                    filterData.map((val, index) => {
                      // console.log("val=", val)
                      return (
                        // <div className=" col-12 col-md-4 col-sm-6 col-xl-3  mb-3 pe-2">

                        // </div>
                        <div
                          onClick={() => catagoryHandle(val.id, val.name)}
                          className="col-sm-12 col-md-6 col-lg-4"
                        >
                          <div className="d-flex  border m-2  categoryBoxMainDiv">
                            <img
                              className="categoryImgBox"
                              height={80}
                              width={80}
                              src={val.image}
                              alt=""
                            />
                            {/* <div className='categoryImgBox '>

                      </div> */}
                            <div>
                              <div className="categoryNameDiv">
                                {isTabletView ? (
                                  <p className="mb-0 fw-bold">
                                    {val.name.length > 50
                                      ? `${val.name.slice(0, 50)}...`
                                      : val.name}
                                  </p>
                                ) : (
                                  <p className="mb-0 fw-bold">
                                    {val.name.length > 40
                                      ? `${val.name.slice(0, 40)}...`
                                      : val.name}
                                  </p>
                                )}
                              </div>
                              <div className="d-flex ">
                                <p>
                                  {val.unique_authors_count}{" "}
                                  {val.unique_authors_count <= 1
                                    ? "Author"
                                    : "Authors"}
                                </p>
                                <p className="ps-4">
                                  {val.post_count}{" "}
                                  {val.post_count <= 1 ? "Article" : "Articles"}{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div>
                      {/* {console.log("520")} */}
                      <Spinner />
                    </div>
                  )}
                </div>
                <div className="d-flex justify-content-center">
                  {!spnierLoading && filterData?.length > 0 ? (
                    <ReactPaginate
                      containerClassName={"pagination-package"}
                      pageClassName={"page-item-package"}
                      activeClassName={"active-package"}
                      onPageChange={(event) => setPage(event.selected)}
                      pageCount={Math.ceil(categoriesWithCount.length / n)}
                      breakLabel="..."
                      previousLabel={
                        <IconContext.Provider
                          value={{ color: "#B8C1CC", size: "36px" }}
                        >
                          {/* <AiFillLeftCircle /> */}
                          <div className="prev-btn">
                            <FaArrowLeft size={20} color="black" /> Previous{" "}
                          </div>
                        </IconContext.Provider>
                      }
                      nextLabel={
                        <IconContext.Provider
                          value={{ color: "#B8C1CC", size: "36px" }}
                        >
                          {/* <AiFillRightCircle /> */}
                          <div className="next-btn">
                            {" "}
                            Next <FaArrowRight size={20} color="black" />{" "}
                          </div>
                        </IconContext.Provider>
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ) : (
            <h3 className="text-center">No Data Found</h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchLandingPage;
